export class StorageConstants {
    public static readonly UserName = 'UserName';
    public static readonly AccountInfo = 'accountInfo';
    public static readonly CompanyCode = 'CompanyCode';
    public static readonly CompanyId = 'CompanyId';
    public static readonly PersonListFromObjectId = 'PersonListFromObjectId';
    public static readonly ObjectId = 'objectId';
    public static readonly CanImpersonate = 'CanImpersonate';
    public static readonly ScreenPermissions = 'screenpermssions';
    public static readonly UserAccess = 'userAccess';
    public static readonly CISearch = 'CISearch';
    public static readonly GoBackTwice = 'GoBackTwice';
    public static readonly EcmSearch = 'EcmSearch';
    public static readonly ProgramSearch = 'ProgSearch';
    public static readonly WriteOffCauseSearch = 'WOSeacrh';
    public static readonly WriteOffErrorTypeSearch = 'WOErrorTypeSearch';
    public static readonly PayorSearch = 'PayorSearch';
    public static readonly ShiftMaintenanceSearch = 'ShiftMaintenanceSearch';
    public static readonly feeTypeSearch = 'FeeTypeSearch';
    public static readonly fundingTypeSearch = 'FundingTypeSearch';
    public static readonly FundingSourceSearch = 'FundingSourceSearch';
    public static readonly BillCodeSearch = 'BillCodeSearch';
    public static readonly accountSearch = 'AccountSearch';
    public static readonly PayrollTemplateSearch = 'PayrollTemplateSearch';
    public static readonly ClientSelectedSearch = 'ClientSelectedSearch';
    public static readonly EmployeeSelectedSearch = 'EmployeeSelectedSearch';
    public static readonly ClaimTemplateSearch = 'ClaimTemplateSearch';
    public static readonly ClaimSummaryInquirySearch = 'ClaimSummaryInquirySearch';
    public static readonly claimsProgramConfigSearch = 'ClaimsProgramConfigSearch';
    public static readonly ClaimBatchSearch = 'ClaimBatchSearch';
    public static readonly FeeRateSearch = 'FeeRateSearch';
    public static readonly ServiceCodeSearch = 'ServiceCodeSearch';
    public static readonly ProgramTypeSearch = 'ProgramTypeSearch';
    public static readonly DiagCodeSearch = 'DiagcodeSearch';
    public static readonly EdiConfigSearch = 'EdiConfigSearch';
    public static readonly RedirectUri = 'adal.login.request';
    public static readonly ClaimDetailsInquiryRedirectUri = 'ClaimDetailsInquiryRedirectUri';
    public static readonly ServiceTypeSearch = 'ServiceTypeSearch';
    public static readonly RepresentativeSelectedRelation = 'RepresentativeSelectedRelation';
    public static readonly ClientRepSelectedRelation = 'ClientRepSelectedRelation';
    public static readonly CaseManagerSelectedRelation = 'CaseManagerSelectedRelation';
    public static readonly CaseManagerSelectedSearch = 'CaseManagerSelectedSearch';
    public static readonly PtpCMSelectedRelation = 'PtpCMSelectedRelation';
    public static readonly AuthorizationsSearch = 'AuthorizationsSearch';
    public static readonly UnappliedPaymentSummaryInquirySearch = 'UnappliedPaymentSummaryInquirySearch';
    public static readonly UnappliedPaymentInquiryRedirectUri = 'UnappliedPaymentInquiryRedirectUri';
    public static readonly PayrollBatchReviewSystem = 'PayrollBatchReviewSystem';
    public static readonly PayrollBatchReviewStart = 'PayrollBatchReviewStart';
    public static readonly PayrollBatchReviewEnd = 'PayrollBatchReviewEnd';
    public static readonly PayrollBatchReviewPayor = 'PayrollBatchReviewPayor';
    public static readonly PayrollBatchReviewCaregiver = 'PayrollBatchReviewCaregiver';
    public static readonly PayrollBatchReviewIsTimeWorked = 'PayrollBatchReviewIsTimeWorked';
    public static readonly PayrollBatchReviewIsAbsence = 'PayrollBatchReviewIsAbsence';
    public static readonly PayrollBatchReviewRunId = 'PayrollBatchReviewRunId';
    public static readonly PayrollBatchReviewStatus = 'PayrollBatchReviewStatus';
    public static readonly IntegrationJobHistoryRequest = 'IntegrationJobHistoryRequest';
    public static readonly ClientSelectedRelation = 'ClientSelectedRelation';
    public static readonly EmployeeSelectedRelation = 'EmployeeSelectedRelation';
    public static readonly ClientSelected = 'ClientSelected';
    public static readonly EmployeeSelected = 'EmployeeSelected';
    public static readonly PayerSelected = 'PayerSelected';
    public static readonly ClientSelectedRates = 'ClientSelectedRates';
    public static readonly CaregiverEmployerSelected = 'CaregiverEmployerSelected';
    public static readonly IsCgvEmpRelationshipComboBoxEnabled = 'IsCgvEmpRelationshipComboBoxEnabled';
    public static readonly ServiceCodeValues = 'ServiceCodeValues';
    public static readonly ServiceCodeValuesDeleted = 'ServiceCodeValuesDeleted';
    public static readonly EmployerCostRateSearch = 'EmployerCostRateSearch';
}
